interface MyWindow extends Window {
    snaptr: any;
}

declare const window: MyWindow;

export default window.snaptr;
